export const getProgramType = (type: string, query: string) => {
  if (type?.toLowerCase()?.includes(query)) {
    return true;
  } else {
    return false;
  }
};

export const isValidDate = (date: string | null) => {
  return date !== null && date.includes("0001-01-01") === false;
};

export const getNormalizedModeOfEntry = (modeOfEntry?: string) =>
  modeOfEntry?.trim().toLowerCase().replace(/\s+/g, "");
